import FAQ from "components/Blocks/FAQ"

const faqContent = {
  sections: [
    {
      title: null,
      faqs: [
        {
          question: "What is Preset Managed Private Cloud?",
          answer:
            "Preset Managed Private Cloud deploys the full Preset platform in your own cloud environment (AWS, GCP, or Azure). Your data never leaves your VPC, while Preset manages the infrastructure, updates, and maintenance.",
        },
        {
          question: "How is Managed Private Cloud different from Preset Cloud?",
          answer:
            "With Preset Cloud, your data is processed in Preset's multi-tenant infrastructure. With Managed Private Cloud, the entire Preset platform runs in your own cloud account. You get the same features but with complete data residency control.",
        },
        {
          question:
            "What cloud providers does Preset Managed Private Cloud support?",
          answer:
            "Preset Managed Private Cloud supports AWS, Google Cloud Platform (GCP), and Microsoft Azure. The deployment runs entirely within your cloud account using your existing VPC and networking configuration.",
        },
        {
          question: "Is Managed Private Cloud HIPAA compliant?",
          answer:
            "Yes. Preset Managed Private Cloud supports HIPAA-eligible deployments. Combined with customer-managed encryption keys and data never leaving your VPC, it meets strict healthcare and financial regulatory requirements.",
        },
        {
          question: "Who manages the infrastructure in Managed Private Cloud?",
          answer:
            "Preset manages everything: provisioning, updates, scaling, monitoring, and maintenance. You provide the cloud account and network access; Preset handles the operational burden while your data stays in your environment.",
        },
        {
          question: "Can I use private networking with Managed Private Cloud?",
          answer:
            "Yes. Because Managed Private Cloud runs inside your own AWS, GCP, or Azure account, traffic stays within your virtual network. Private networking options such as VPC peering and AWS PrivateLink are supported, and your databases can remain on private subnets with no public internet exposure.",
        },
        {
          question: "What security certifications does Preset have?",
          answer:
            "Preset is SOC 2 Type II certified. Managed Private Cloud deployments also support customer-managed encryption keys, SSO/SAML authentication, audit logging, and HIPAA-eligible configurations.",
        },
        {
          question: "How does billing work for Managed Private Cloud?",
          answer:
            "Managed Private Cloud is available on Enterprise plans with custom pricing based on your requirements. You pay Preset for the managed service and pay your cloud provider directly for infrastructure costs.",
        },
      ],
    },
  ],
}

function FAQSection() {
  return (
    <FAQ
      label="Common Questions"
      heading="Frequently Asked Questions"
      content={faqContent}
    />
  )
}

export default FAQSection
